var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11Admine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_1-admine_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222"
    },
    d: "M20.9,4.4c0-0.2-0.1-0.4-0.4-0.5c-2.9-0.8-5.7-2-8.3-3.5c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0C8.9,1.9,5.9,3,2.9,3.9C2.7,4,2.6,4.1,2.5,4.4 c-0.4,4.2-0.3,8.5,1.7,12.3c0.8,1.5,1.9,2.9,3.1,4c0.7,0.6,1.4,1.1,2.1,1.5c0.6,0.3,1.5,0.9,2.2,0.9c0.7,0,1.6-0.6,2.2-0.9 c0.8-0.4,1.5-0.9,2.1-1.5c1.3-1.1,2.3-2.5,3.1-4C21.1,12.9,21.3,8.5,20.9,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M18.6,15.5c-0.7,1.5-1.6,2.8-2.8,3.9c-0.9,0.9-2.7,2.4-4.1,2.4c-1.4,0-3.2-1.5-4.1-2.4 c-1.2-1.1-2.1-2.5-2.8-3.9C3.2,12.2,3.1,8.4,3.5,4.7C6.4,3.9,9.3,2.8,12,1.3c2.5,1.4,5.2,2.6,8,3.4C20.3,8.4,20.2,12.2,18.6,15.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.9748,
    y1: 7.2537,
    x2: 11.3323,
    y2: 7.2537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M11.3,3.1c0,0-2.7,2.1-6.4,2.7c0,3.7,0,5.6,0,5.6h6.4V3.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.0004,
    y1: 16.1645,
    x2: 18.1579,
    y2: 16.1645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M18.2,12c0,0-0.3,1.4-0.3,1.4c-0.9,3.1-3.3,5.2-5.9,6.9V12C12,12,18.2,12,18.2,12z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11Admine);
export default __webpack_public_path__ + "static/media/11-admine.a5b9d239fdce20815ded8ee0f978784d.svg";
export { ForwardRef as ReactComponent };